import {LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, Label} from 'recharts';
import React, {useMemo, useState} from "react";
import styles from "./VaultChart.module.scss";
import moment from "moment/moment";
import {AdapterMoment} from "@mui/x-date-pickers/AdapterMoment";
import {DateTimePicker} from "@mui/x-date-pickers/DateTimePicker";
import {LocalizationProvider} from "@mui/x-date-pickers/LocalizationProvider";

const VaultChart = (props) => {
    const {
        data,
    } = props;
    
    const [filterStartDate, setFilterStartDate] = useState();
    const [filterEndDate, setFilterEndDate] = useState();

    const filteredData = useMemo(() => {
        if (!filterStartDate && !filterEndDate) return data;

        return data.filter(row => {
            if (filterStartDate) {
                const rowDate = moment(row.date);
                if (rowDate.isBefore(filterStartDate)) return false;
            }
            if (filterEndDate) {
                const rowDate = moment(row.date);
                if (rowDate.isAfter(filterEndDate)) return false;
            }
            return true;
        });
    }, [filterStartDate, filterEndDate]);

    return (
        <div>
            <LocalizationProvider dateAdapter={AdapterMoment}>
                <DateTimePicker
                    value={filterStartDate}
                    onChange={(value) => setFilterStartDate(value)}
                    label="Filter Start Date"/>
                <DateTimePicker
                    value={filterEndDate}
                    onChange={(value) => setFilterEndDate(value)}
                    label="Filter End Date"/>
            </LocalizationProvider>
            <div className={styles.chartContainer}>
                <ResponsiveContainer width="100%" height="100%">
                    <LineChart
                        width={500}
                        height={300}
                        data={filteredData}
                        margin={{
                            top: 5,
                            right: 30,
                            left: 20,
                            bottom: 5,
                        }}
                    >
                        <CartesianGrid strokeDasharray="3 3"/>
                        <XAxis dataKey="date">
                            <Label value="Date" offset={0} position="insideBottom"/>
                        </XAxis>
                        <YAxis/>
                        <Tooltip/>
                        <Legend/>
                        <Line type="monotone" dataKey="Vaults Per Day" stroke="#82ca9d" activeDot={{r: 8}}>

                        </Line>
                        <Line type="monotone" dataKey="90Day" stroke="#131E25"/>
                        <Line type="monotone" dataKey="180Day" stroke="#8D71FF"/>
                        <Line type="monotone" dataKey="360Day" stroke="#FFCC26"/>
                    </LineChart>
                </ResponsiveContainer>
            </div>
            <div className={styles.chartContainer}>
                <ResponsiveContainer width="100%" height="100%">
                    <LineChart
                        width={500}
                        height={300}
                        data={filteredData}
                        margin={{
                            top: 5,
                            right: 30,
                            left: 20,
                            bottom: 5,
                        }}
                    >
                        <CartesianGrid strokeDasharray="3 3"/>
                        <XAxis dataKey="date">
                            <Label value="Date" offset={0} position="insideBottom"/>
                        </XAxis>
                        <YAxis/>
                        <Tooltip/>
                        <Legend/>
                        <Line type="monotone" dataKey="Staked Amount Per Day" stroke="#82ca9d" activeDot={{r: 8}}>

                        </Line>
                    </LineChart>
                </ResponsiveContainer>
            </div>
            <div className={styles.chartContainer}>
                <ResponsiveContainer width="100%" height="100%">
                    <LineChart
                        width={500}
                        height={300}
                        data={filteredData}
                        margin={{
                            top: 5,
                            right: 30,
                            left: 20,
                            bottom: 5,
                        }}
                    >
                        <CartesianGrid strokeDasharray="3 3"/>
                        <XAxis dataKey="date">
                            <Label value="Date" offset={0} position="insideBottom"/>
                        </XAxis>
                        <YAxis/>
                        <Tooltip/>
                        <Legend/>
                        <Line type="monotone" dataKey="Total Staked Amount" stroke="#82ca9d" activeDot={{r: 8}}>

                        </Line>
                    </LineChart>
                </ResponsiveContainer>
            </div>
            <div className={styles.chartContainer}>
                <ResponsiveContainer width="100%" height="100%">
                    <LineChart
                        width={500}
                        height={300}
                        data={filteredData}
                        margin={{
                            top: 5,
                            right: 30,
                            left: 20,
                            bottom: 5,
                        }}
                    >
                        <CartesianGrid strokeDasharray="3 3"/>
                        <XAxis dataKey="date">
                            <Label value="Date" offset={0} position="insideBottom"/>
                        </XAxis>
                        <YAxis/>
                        <Tooltip/>
                        <Legend/>
                        <Line type="monotone" dataKey="Total Created Vaults" stroke="#82ca9d" activeDot={{r: 8}}>

                        </Line>
                    </LineChart>
                </ResponsiveContainer>
            </div>
        </div>
    );
}

export default VaultChart;
